import React, { useContext } from "react";
import PsContext from "../../context";
import { Link } from "react-router-dom";

const OpenPaymentFormLink = (props) => {
  const context = useContext(PsContext);

  const pageContent = () => {
    let c = context.settingValue("stu_open_payment_link_description", "");
    if (c && c.trim().length > 3) return c;
    else return "Open Form Payment";
  };

  return (
    <>
      {context.settingValue("stu_open_payment_link", "") == "1" && (
        <div className="mt-4 text-center fs-6">
          <Link to="/stu/open-form">{pageContent()}</Link>
        </div>
      )}
    </>
  );
};
export default OpenPaymentFormLink;
